// Today helpers — same logic as the API so the UI looks consistent with what
// gets persisted. All "today" decisions are made in Asia/Kolkata.

const IST_OFFSET_MIN = 330;

export function todayIST(now: Date = new Date()): string {
  const utc = new Date(now.getTime() + IST_OFFSET_MIN * 60 * 1000);
  return utc.toISOString().slice(0, 10);
}

export function daysRemainingInYear(now: Date = new Date()): number {
  const shifted = new Date(now.getTime() + IST_OFFSET_MIN * 60 * 1000);
  const year = shifted.getUTCFullYear();
  const nextYearStart = Date.UTC(year + 1, 0, 1);
  const todayUtc = Date.UTC(year, shifted.getUTCMonth(), shifted.getUTCDate());
  return Math.ceil((nextYearStart - todayUtc) / (24 * 3600 * 1000));
}
